/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf32.png';

const MarketShareStep8 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    hideAlert={true}
    subTitle="Product Market Fit"
    paragraph2={(
      <Fragment>
        When companies are building products, they consider the size of the opportunity
        (i.e. demand) in the development process partly because investors love big markets!
        Marc Andreessen, an influential venture capitalist in Silicon Valley,
        believes <a href="https://pmarchive.com/guide_to_startups_part4.html" rel="noreferrer" target="_blank">market size is "the only thing that matters"</a>.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep8;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step8.js